module.exports = __webpack_public_path__ + "assets/SquareInCircle.d1b4dc825128aa41942bf511a03e5a00.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/SquareInCircle.gmt
// module id = 1000
// module chunks = 0